import React from 'react';
import { useAtom } from 'jotai';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import PartnerNetwork from '../../Assets/AlertIcon/partner_network.svg';
import myNetwork from '../../Assets/AlertIcon/my_network.svg';
import { noNetwork, partnerNetwork } from '../../common/atom/atoms';
const PartnerAndNetwrokButtons = (props) => {
  const [noNetworks, setNoNetworks] = useAtom(noNetwork);
  const { onlyNetwork } = props;
  const [partnerNetworks, setPartnerNetworks] = useAtom(partnerNetwork);
  return (
    <>
      <div
        style={{
          position: 'absolute',
          bottom: '10px',
          left: '10px',
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          zIndex: 1,
        }}
      >
        <div data-svg-wrapper style={{ marginLeft: '5px', display: 'flex', gap: '10%' }}>
          <div
            style={{
              width: '100%',
              height: '100%',
              background: !noNetworks ? '#192126' : 'white',
              boxShadow: '0px 0px 4.72px 1.18px rgba(0, 0, 0, 0.25)',
              borderRadius: 5.67,
              outline: '2.36px rgba(0, 0, 0, 0.20) solid',
              transition: 'all 0.3s ease-in-out',
              cursor: 'pointer', // Makes it clear it's interactive
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#A0A2A4';
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = !noNetworks ? '#192126' : 'white';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            <div
              style={{
                width: '100%',
                height: '100%',
                marginTop: '4px',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'center',
                gap: 5.67,
                display: 'inline-flex',
              }}
              onClick={() => setNoNetworks(!noNetworks)}
            >
              <div
                style={{
                  marginTop: '4px',
                  width: 34,
                  height: 34,
                  background: '#E8E9E9',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: 5.67,
                  transition: 'all 0.3s ease-in-out',
                }}
              >
                <div
                  style={{
                    width: 22.67,
                    height: 22.67,
                    position: 'relative',
                    overflow: 'hidden',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <img src={myNetwork} alt="My Network" />
                </div>
              </div>
              <div
                style={{
                  width: 62.33,
                  marginBottom: '5px',
                  textAlign: 'center',
                  justifyContent: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  color: noNetworks ? 'black' : 'white',
                  fontSize: 7.93,
                  fontFamily: 'Inter',
                  fontWeight: '500',
                  wordWrap: 'break-word',
                }}
              >
                My network
              </div>
            </div>
          </div>

          {onlyNetwork ? null : (
            <div
              style={{
                width: '100%',
                height: '100%',
                background: partnerNetworks ? 'black' : 'white',
                boxShadow: '0px 0px 4.72px 1.18px rgba(0, 0, 0, 0.25)',
                borderRadius: 5.67,
                outline: '2.36px rgba(0, 0, 0, 0.20) solid',
                transition: 'all 0.3s ease-in-out',
                cursor: 'pointer', // Makes it clear it's interactive
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#A0A2A4';
                e.currentTarget.style.transform = 'scale(1.05)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = partnerNetworks ? '#192126' : 'white';
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  marginTop: '4px',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  gap: 5.67,
                  display: 'inline-flex',
                }}
                onClick={() => setPartnerNetworks(!partnerNetworks)}
              >
                <div
                  style={{
                    marginTop: '4px',
                    width: 34,
                    height: 34,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.3s ease-in-out',
                    background: '#E8E9E9',
                    borderRadius: 5.67,
                  }}
                  // onMouseEnter={(e) => {
                  //     e.currentTarget.style.background = '#A0A2A4';
                  // }}
                  // onMouseLeave={(e) => {
                  //     e.currentTarget.style.background = '#E8E9E9';
                  // }}
                >
                  <div
                    style={{
                      width: 22.67,
                      height: 22.67,
                      position: 'relative',
                      overflow: 'hidden',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <img src={PartnerNetwork} alt="Partner Network" />
                  </div>
                </div>
                <div
                  style={{
                    width: 67.33,
                    marginBottom: '5px',
                    textAlign: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    color: partnerNetworks ? 'white' : 'black',
                    fontSize: 7.93,
                    fontFamily: 'Inter',
                    fontWeight: '500',
                    wordWrap: 'break-word',
                  }}
                >
                  Partner Netwrok
                </div>
              </div>
            </div>
          )}

          {/* <div style={{ width: '100%', height: '100%', background: 'white', display: 'flex', boxShadow: '0px 0px 4.722222328186035px 1.1805555820465088px rgba(0, 0, 0, 0.25)', borderRadius: 5.67, outline: '2.36px rgba(0, 0, 0, 0.20) solid' }} >
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            marginTop: "4px",
                            paddingTop: 2.83,
                            paddingBottom: 2.83,
                            background: "white",
                            borderRadius: 5.67,
                            flexDirection: "column",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            gap: 5.67,
                            cursor: 'pointer',
                            display: "inline-flex"
                        }}
                    // onClick={()=>setNoNetworks(!noNetworks)}
                    // onMouseEnter={(e) => {
                    //     e.currentTarget.style.background = 'white';
                    //     e.currentTarget.style.transform = 'scale(1.05)';
                    // }}
                    // onMouseLeave={(e) => {
                    //     e.currentTarget.style.background = 'white';
                    //     e.currentTarget.style.transform = 'scale(1)';
                    // }}
                    >
                        <div
                            style={{
                                width: 34,
                                height: 34,
                                background: "#E8E9E9",
                                borderRadius: 5.67,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <img src={myNetwork} alt="My Network" />
                        </div>

                        <div
                            style={{
                                width: 62.33,
                                marginBottom: '5px',
                                textAlign: 'center',
                                justifyContent: 'center',
                                display: 'flex',
                                flexDirection: 'column',
                                color: 'black',
                                fontSize: 7.93,
                                fontFamily: 'Inter',
                                fontWeight: '500',
                                wordWrap: 'break-word'
                            }}
                        >
                            My network
                        </div>
                    </div>
                    <div style={{ width: '100%', marginTop: '9px', marginBottom: '9px', transformOrigin: 'top left', marginRight: '5px', outline: '1px #E8E9E9 solid', outlineOffset: '-0.50px' }}></div>
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            marginTop: "4px",
                            paddingTop: 2.83,
                            paddingBottom: 2.83,
                            background: "white",
                            borderRadius: 5.67,
                            flexDirection: "column",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            gap: 5.67,
                            cursor: 'pointer',
                            display: "inline-flex",
                            marginRight: '6px'
                        }}
                    // onMouseEnter={(e) => {
                    //     e.currentTarget.style.background = 'white';
                    //     e.currentTarget.style.transform = 'scale(1.05)';
                    // }}
                    // onMouseLeave={(e) => {
                    //     e.currentTarget.style.background = 'white';
                    //     e.currentTarget.style.transform = 'scale(1)';
                    // }}
                    >
                        <div
                            style={{
                                width: 34,
                                height: 34,
                                background: "#E8E9E9",
                                borderRadius: 5.67,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <img src={PartnerNetwork} alt="Partner Network" />
                        </div>

                        <div
                            style={{
                                width: 62.33,
                                marginBottom: '5px',
                                textAlign: 'center',
                                justifyContent: 'center',
                                display: 'flex',
                                flexDirection: 'column',
                                color: 'black',
                                fontSize: 7.93,
                                fontFamily: 'Inter',
                                fontWeight: '500',
                                wordWrap: 'break-word'
                            }}
                        >
                            Partner network
                        </div>
                    </div>

                </div> */}
        </div>
      </div>
    </>
  );
};

export default PartnerAndNetwrokButtons;
